import React from "react"
import { Tooltip, IconButton, Button } from "@material-ui/core"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"

const DownloadSample = ({ exportSample, files,template}) => {
  const handleClose = (event, files, DownSample) => {
    if (DownSample) {
      exportSample(files)
    }
  }

  return (
    <>
      {/* <Tooltip title="">
        <IconButton
          variant="outlined"
          color="primary"
          onClick={(event) => handleClose(event, files, "triggerExport")}
          files={{ title: "Download Sample", extension: "xlsx", key: "" }}
        >
          <ExitToAppIcon className="import-task-icon download" />

          {files.extension === "docx"}
          {files.title}
        </IconButton>
      </Tooltip> */}
      <Button
        variant={template ? "text":"outlined"}
        color="primary"
        onClick={(event) => handleClose(event, files, "triggerExport")}
        files={{ title: "Download Sample", extension: "xlsx", key: "" }}
      >
       <span style={{color:"#3f51b5"}}>{files.title}</span> 
      </Button>
    </>
  )
}

export default DownloadSample
